import { Bell } from "lucide-react";
import { cn } from "@/lib/utils";
import { HEADER_TOOL_BTN_CLASS, HEADER_TOOL_ICON_CLASS } from "./HeaderToolButton";

interface NotificationBellProps {
  className?: string;
}

/** Placeholder until admin notification API is wired. */
export function NotificationBell({ className }: NotificationBellProps) {
  return (
    <button
      type="button"
      aria-label="Notifications"
      className={cn(
        HEADER_TOOL_BTN_CLASS,
        "relative bg-card text-muted-foreground ring-border hover:bg-muted/50 hover:text-foreground",
        className,
      )}
    >
      <Bell className={HEADER_TOOL_ICON_CLASS} />
    </button>
  );
}
